import * as React from 'react';
import Guide from '@components/guide/guide.component';
import {WithStyles} from "@material-ui/core/styles";
import {ScheduleCreateStyles} from "@components/onboarding/steps/StepScheduleCreate/scheduleCreate.styles";
import {withStyles} from "@material-ui/core";

interface IScheduleCreateNewProps extends WithStyles<typeof ScheduleCreateStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    classes: any;
}

class ScheduleCreateNew extends React.Component<IScheduleCreateNewProps> {
    constructor(props: IScheduleCreateNewProps) {
        super(props);
    }

    public render() {
        const {classes: style} = this.props;

        return (
            <div className={style.root}>
                <div className={style.background}>
                    <div className={style.circle}/>
                </div>
                <Guide
                    style={{minHeight:'100vh'}}
                    progress={this.props.progress}
                    firstSchedule={true}
                    cancelCallback={() => this.props.nextStep()}
                    nextStep={this.props.nextStep}
                    isOnboarding={true}
                    completedCallback={() => this.props.nextStep()}
                />
            </div>
        );
    }
}

export default withStyles(ScheduleCreateStyles)(ScheduleCreateNew)  ;



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepScheduleCreate/scheduleCreate.component.tsx